<template>
  <div ref="imgScroll" class="contatiner">
    <div class="bg">
      <!-- <img src="@/assets/extensionPage/pcbanner.jpg" alt="" /> -->
    </div>
    <PlayVideo v-if="showMask" ref="PlayVideo" />
    <img
      class="rotateImg"
      src="@/assets/extensionPage/pccircle.png"
      @click="openVideo"
    >
    <div class="around">
      <img src="@/assets/extensionPage/pcaction.png" @click="openVideo">
    </div>
    <img
      class="download"
      src="@/assets/extensionPage/pcdown.png"
      @click="downLoad"
    >
  </div>
</template>
<script>
import PlayVideo from "@/components/PlayVideo";
import device from "@/utils/GetDeviceInformation";
import { reqGetLinks } from "@/api/news.js"
import { getLinksParams } from "@/utils/getDownloadLinks.js"

export default {
  name: "ExtensionPagePc",
  components: { PlayVideo },
  data() {
    return {
      showMask: false,
      lostworld_ios: "",
      lostworld_android: "",
      lostworld_pc: ""
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.taptop();
    // }, 10);
    // const ele = document.getElementById("nav");
    // const top = document.documentElement.offsetHeight;
    // console.log(ele);
    // this.$nextTick(() => {
    //   ele.style.height = top;
    //   console.log(ele.style);
    // });
  },
  created() {
    this.getDownloadLinks()
  },
  methods: {
    openVideo() {
      this.showMask = true;
    },
    clickDownLoad(url, type) {
      const link = document.createElement('a');
      if (type === 'lostworld_android') {
        const ourkey = 'RILvS9HYMOsiFptQ75dgW38V6Bh2Jyw';
        const time = Date.parse(new Date()) / 1000;
        const uri = url.split("com")[1]; // 取com后面的所有值
        const key = this.$md5(`${uri}${ourkey}${time}`); // 转 md5 密钥计算参数

        link.href = url + `?key=${key}&time=${time}`; // 设置下载链接
      } else {
        link.href = url; // 设置下载链接
      }
      link.download = url.substring(url.lastIndexOf("/") + 1); // 设置下载文件的名称 取最后一个/后面的内容为下载名字
      // 将 <a> 标签添加到 DOM 中
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 删除添加的 <a> 标签
      document.body.removeChild(link);
    },
    downLoad() {
      if (device === "ios") {
        this.clickDownLoad(this.lostworld_ios)
      } else {
        this.clickDownLoad(this.lostworld_android, 'lostworld_android')
      }
    },
    taptop() {
      this.$nextTick(() => {
        const ele = document.getElementsByClassName("contatiner")[0];
        document.documentElement.scrollTop = ele.scrollHeight;
      });
    },
    async getDownloadLinks() {
      const res = await reqGetLinks(getLinksParams)

      res.data.forEach(item => {
        this[item.keywords] = item.data
      })
    }
  }
};
</script>
 <style lang='scss' scoped>
@-webkit-keyframes changeright {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@-moz-keyframes changeright {
  from {
    -moz-transform: rotate(0deg);
  }

  to {
    -moz-transform: rotate(360deg);
  }
}

@keyframes changeright {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.contatiner {
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  // overflow-y: auto;
  // overflow: hidden;
  position: relative;
  .bg {
    width: 100%; // z-index: 0;
    height: 100%;
    background: url("~@/assets/extensionPage/pcbanner.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .download {
    position: absolute;
    top: 84%;
    left: 38.5%;
    width: 435px;
    height: 92px;
  }
  .rotateImg {
    width: 11.2%;
    position: absolute;
    top: 47%;
    left: 44.45%;
    animation: changeright 5s linear infinite;
  }
  .around {
    width: 100%;
    //transform: translateY(-50%);
    //  text-align: center;
    img {
      position: absolute;
      top: 50.05%;
      left: 46.05%;
      width: 8%;
      opacity: 0.8;
    }
  }
}
</style>

